module.exports = __webpack_public_path__ + "static/media/wav.d165116c.png";